import { useState } from "react";
import { IonButton, IonIcon, IonContent, IonList, IonItem, IonLabel, IonNote } from "@ionic/react";
import { caretDownOutline } from "ionicons/icons";
import FreshPopover from "@/components/FreshPopover";
import { LANGUAGES } from "@/utils/i18n";

export const flagSrc = (flag) => `/assets/images/${flag}_flag.svg`;

// The settings page's language control: a small clear button wearing the
// language's flag, its code and a caret, opening the house menu popover (the
// top bar's page menu: 240 wide, 48px rows, inset hairlines) that lists every
// language as its flag, its native name and its code, the current one tinted.
// The names stay in their own language, so the live translator leaves this
// control alone.
const row = { "--min-height": "48px", "--padding-start": "14px", "--inner-padding-end": "14px", "--background": "transparent", "--color": "var(--ion-text-color)", "--border-color": "var(--app-divider, var(--ion-border-color))", fontSize: "0.9rem" };

export default function LanguagePicker({ value, onChange }) {
  const [menu, setMenu] = useState({ open: false, event: undefined });
  const current = LANGUAGES.find((l) => l.code === value) || LANGUAGES[0];
  const close = () => setMenu({ open: false, event: undefined });
  return (
    <>
      <IonButton fill="clear" size="small" className="translation-select-btn" data-i18n="off"
        onClick={(e) => setMenu({ open: true, event: e.nativeEvent })} aria-label="Language">
        <img slot="start" className="lang-flag-btn" src={flagSrc(current.flag)} alt="" />
        {current.code.toUpperCase()}
        <IonIcon slot="end" icon={caretDownOutline} />
      </IonButton>
      <FreshPopover open={menu.open} event={menu.event} onClose={close} side="bottom" alignment="end" style={{ "--width": "240px" }}>
        <IonContent>
          <IonList className="language-menu" data-i18n="off" style={{ padding: "4px 0" }}>
            {LANGUAGES.map((l, i) => (
              <IonItem key={l.code} button detail={false} lines={i === LANGUAGES.length - 1 ? "none" : "inset"}
                className={l.code === value ? "is-selected" : undefined} aria-current={l.code === value ? "true" : undefined}
                style={row} onClick={() => { close(); onChange(l.code); }}>
                <img slot="start" className="lang-flag" src={flagSrc(l.flag)} alt="" />
                <IonLabel>{l.name}</IonLabel>
                <IonNote slot="end">{l.code.toUpperCase()}</IonNote>
              </IonItem>
            ))}
          </IonList>
        </IonContent>
      </FreshPopover>
    </>
  );
}
